import React from 'react';

type SvgProps = {
    color: string;
    size?: number;
};

const Communication: React.FC<SvgProps> = ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.41135 0.964844H19.4906C20.6648 0.964844 21.6255 1.92555 21.6255 3.09976V15.9092C21.6255 17.0834 20.6648 18.0441 19.4906 18.0441H4.54626L0.287109 22.314V3.09976C0.287109 1.92555 1.23714 0.964844 2.41135 0.964844ZM17.3555 8.43705H4.54599V10.572H17.3555V8.43705ZM13.0856 13.7743H4.54599V11.6394H13.0856V13.7743ZM4.54599 7.36956H17.3555V5.23465H4.54599V7.36956Z" fill={color} />
    </svg>


);

export default Communication;
